module.exports = __webpack_public_path__ + "img/Newbie_Shield_02_Classic.3e422c80.png";